/**
 * Function that extracts the public and private Vimeo ids from the video's url.
 * There will always exist a public source id for the Vimeo video, however if a private id doesn't exist, i,e the video
 * is a public Vimeo video, then the private id will be undefined and will be returned as such.
 *
 * @param {string} url Vimeo video url.
 * @returns {Object} sourceId and privateId of the Vimeo video.
 */
export function extractVimeoVideoIdsFromUrl(url) {
  if (!_.isString(url)) throw Error("The sole argument for extractPrivateIdFromVimeoUrl() must be of type 'String'");
  const vimeoVideoIds = url.split('/');
  return {
    sourceId: vimeoVideoIds[0],
    privateId: (vimeoVideoIds[1]) ? vimeoVideoIds[1] : undefined,
  };
}
